const urls = Object.freeze({
	schedules: {
		url: () => `/v1/schedules`,
		user: {
			url: () => `${urls.schedules.url()}/user`,
			timeline: {
				url: () => `${urls.schedules.user.url()}/timeline`,
				export: {
					url: () => `${urls.schedules.user.timeline.url()}/export`,
				},
			},
			userId: {
				url: (
					{ userId } = {
						userId: ':userId',
					},
				) => `${urls.schedules.user.url()}/${userId}`,
			},
		},
		onCalls: {
			url: () => `${urls.schedules.url()}/on-calls`,
		},
		scheduleId: {
			url: (
				{ scheduleId } = {
					scheduleId: ':scheduleId',
				},
			) => `${urls.schedules.url()}/${scheduleId}`,
			timeline: {
				url: (
					{ scheduleId } = {
						scheduleId: ':scheduleId',
					},
				) => `${urls.schedules.scheduleId.url({ scheduleId })}/timeline`,
			},
		},
	},
	wioc: {
		status: {
			url: () => `${urls.schedules.url()}/user/on-calls`,
		},
	},
	teams: {
		url: () => `/v1/teams`,
	},
} as const);

export const SPOTLIGHT_NAMES = {
	firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period',
};

export const SPOTLIGHT_TOURS = {
	overlappingPeriod: 'eoc-who-is-on-call-overlapping-period',
};

export const WHO_IS_ON_CALL_PAGE_URL = '/jira/ops/who-is-on-call';

export const SEARCH_PEOPLE_AND_TEAM = '/jira/people/search';

export { urls };
